import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["window"]

    connect() {
        this.dragging = false
        this.startX = 0
        this.startY = 0
        this.offsetX = 0
        this.offsetY = 0


        this.windowTarget.addEventListener("mousedown", this.onMouseDown.bind(this))
        document.addEventListener("mousemove", this.onMouseMove.bind(this))
        document.addEventListener("mouseup", this.onMouseUp.bind(this))
    }

    onMouseDown(event) {
        this.dragging = true
        const rect = this.windowTarget.getBoundingClientRect()
        this.startX = event.clientX
        this.startY = event.clientY
        this.offsetX = this.startX - rect.left
        this.offsetY = this.startY - rect.top
    }

    onMouseMove(event) {
        if (this.dragging) {
            const newX = event.clientX - this.offsetX
            const newY = event.clientY - this.offsetY
            this.windowTarget.style.left = newX + "px"
            this.windowTarget.style.top = newY + "px"
        }
    }

    onMouseUp() {
        this.dragging = false
    }

    resetPosition() {
        this.windowTarget.style.left = "0px"
        this.windowTarget.style.top = "0px"
    }

    disconnect() {
        this.windowTarget.removeEventListener("mousedown", this.onMouseDown)
        document.removeEventListener("mousemove", this.onMouseMove)
        document.removeEventListener("mouseup", this.onMouseUp)
    }
}